import React from "react";

export default function PageHeader({
  eyebrow,
  title,
  subtitle,
  actions,
}) {
  return (
    <div className="page-header">
      <div className="page-header-copy">
        {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
        <h1 className="page-title">{title}</h1>
        {subtitle ? <p className="page-subtitle">{subtitle}</p> : null}
      </div>

      {actions ? <div className="page-header-actions">{actions}</div> : null}
    </div>
  );
}